module.exports = __webpack_public_path__ + "img/J13084.07b5c1b0.png";